(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockPartnerKontaktErlaubnis', {
            require: {
                form: '^form'
            },
            bindings: {
                partner: '=abpkePartner',
                angebotVm: '=abpkeAngebotVm'
            },
            templateUrl: 'bloecke/uwg/blockPartnerKontaktErlaubnis.html',
            transclude: true,
            controller: BlockPartnerKontaktErlaubnisController,
            controllerAs: 'kontakterlaubnisVm'
        });

    BlockPartnerKontaktErlaubnisController.$inject = [
        'lodash',
        'MiscUtilsService',
        'AppConfig'
    ];
    function BlockPartnerKontaktErlaubnisController(_, MiscUtilsService, AppConfig) {
        var vm = this,
            formFieldNames = [
                'kontaktErlaubt'
            ];

        vm.$onInit = onInit;

        function activate() {
            vm.uuid = MiscUtilsService.guid('#');

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    fieldName,
                    vm.uuid
                ].join('_');
            }));

            vm.urlUwgVorteile = AppConfig.APP.urls.uwgvorteile;
            vm.urlDatenschutzhinweise = AppConfig.APP.urls.datenschutzhinweise;
            vm.isBlockInfoLinksSichtbar = isBlockInfoLinksSichtbar;
        }

        function onInit() {
            activate();
        }
        function isBlockInfoLinksSichtbar() {
            return !vm.angebotVm.isAppModus();
        }
    }

})();
